export default __webpack_public_path__ + "img/sun-cloud-storm.24bb994.svg";